module.exports = __webpack_public_path__ + "img/pethouse45.354486e1.jpg";